import {SwiperConfigInterface} from 'ngx-swiper-wrapper';

export abstract class BaseSwiperCardComponent {
  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    spaceBetween: 8,
  };
}
